if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.currentScrollTop = 0;
      this.header = document.querySelector('.section-header');
      this.headerTop = document.querySelector('.header-top');
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.calculateThreshold();

      this.onScroll();
window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      this.setupWindowResizeEvent();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.debouncedOnWindowResize);
    }

    calculateThreshold() {
  const stateClasses = [
    'shopify-section-header-sticky',
    'shopify-section-header-hidden',
    'animate'
  ];

  const activeClasses = stateClasses.filter(className =>
    this.header.classList.contains(className)
  );

  // Measure the full header in its normal layout.
  this.header.classList.remove(...stateClasses);
  this.header.style.removeProperty('min-height');

  const rect = this.header.getBoundingClientRect();
  const scrollTop =
    window.pageYOffset || document.documentElement.scrollTop;

  // Reserve this space when the header becomes sticky.
  this.header.style.setProperty(
    'min-height',
    `${rect.height}px`,
    'important'
  );

  this.headerBoundTop = rect.bottom + scrollTop;
  this.threshold = this.headerBoundTop + 100;

  // Restore the current scrolling state.
  this.header.classList.add(...activeClasses);
}

    onScroll() {
      const scrollTop = document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBoundTop) {
        // Scrolling down and passed the header: hide the sticky header but keep position fixed.
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBoundTop) {
        // Scrolling up and passed the header: show the sticky header.
        if (scrollTop > this.threshold) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBoundTop) {
        // Scroll above the header: reset the sticky header.
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    setupWindowResizeEvent() {
      const headerHeight = this.header.querySelector('header').clientHeight;
      const stickyHeaderHeight = headerHeight + this.getHeaderTopHeight();
      document.body.style.setProperty('--header-height', `${headerHeight}px`);
      
      if (window.innerWidth >= 990) {
        document.body.style.setProperty('--sticky-header-height-desktop', `${stickyHeaderHeight}px`);
      } else {
        document.body.style.setProperty('--sticky-header-height-mobile', `${stickyHeaderHeight}px`);
      }
      
      this.debouncedOnWindowResize = debounce((event) => {
        this.onWindowResize(event);
      }, 500);

      window.addEventListener('resize', this.debouncedOnWindowResize, false);
    }

    onWindowResize() {
      let headerHeight;
      
      if (window.innerWidth >= 990) {
        const navHeight = this.nav.clientHeight;
        document.body.style.setProperty('--nav-height', `${navHeight}px`);
        
        if (this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('open-nav')) {
          headerHeight = this.header.querySelector('header').clientHeight + navHeight + 11;
        } else {
          headerHeight = this.header.querySelector('header').clientHeight;
        }
      } else {
        headerHeight = this.header.querySelector('header').clientHeight;
      }
      
      document.body.style.setProperty('--header-height', `${headerHeight}px`);
      const stickyHeaderHeight = headerHeight + this.getHeaderTopHeight();
      
      if (window.innerWidth >= 990) {
        document.body.style.setProperty('--sticky-header-height-desktop', `${stickyHeaderHeight}px`);
      } else {
        document.body.style.setProperty('--sticky-header-height-mobile', `${stickyHeaderHeight}px`);
      }
      
      this.calculateThreshold();
    }

    getHeaderTopHeight() {
      if (!this.headerTop) {
        return 0;
      }
      return this.headerTop.clientHeight;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  });
}
  /*My JS*/
document.addEventListener("DOMContentLoaded", function() {
  let lastScrollTop = 0;
  const button = document.getElementById("hide");

  window.addEventListener("scroll", function() {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

    if (currentScroll > lastScrollTop) {
      // Scrolling down
      button.style.opacity = "0";
      button.style.pointerEvents = "none"; // Optional: Prevent interaction while hidden
    } else {
      // Scrolling up
      if (currentScroll === 0) {
        // At the top of the page
        button.style.opacity = "1";
        button.style.pointerEvents = "auto"; // Optional: Re-enable interaction
      } else {
        // Not at the top of the page
        button.style.opacity = "0";
        button.style.pointerEvents = "none"; // Optional: Prevent interaction while hidden
      }
    }

    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // For Mobile or negative scrolling
  }, false);
});

